import { render, staticRenderFns } from "./DjangoRouterLink.vue?vue&type=template&id=f2d58a4e"
import script from "./DjangoRouterLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./DjangoRouterLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports